export const scrollIntoView = (element?: Element) =>
  new Promise<void>((resolve) => {
    if (!element || !element.parentElement) return

    onScrollEnd(element.parentElement, resolve)

    element.scrollIntoView({ behavior: "smooth", inline: "center" })
  })

const onScrollEnd = (element: Element, callback: () => void) => {
  if ("onscrollend" in element)
    return element.addEventListener("scrollend", callback, { once: true })

  // A simple "scrolled" polyfill
  // https://developer.chrome.com/blog/scrollend-a-new-javascript-event
  let timeout: ReturnType<typeof setTimeout>

  element.addEventListener("scroll", () => {
    clearTimeout(timeout)
    timeout = setTimeout(callback, 100)
  })
}
